module.exports = __webpack_public_path__ + "img/top_bg_2.1369d0d2.png";